
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(3 3.5)","fill":"#fff"}},[_c('path',{attrs:{"d":"M17.407 8.855a.561.561 0 01-.397-.165 2.364 2.364 0 00-3.264 0 .563.563 0 01-.796-.795 3.434 3.434 0 014.855 0 .563.563 0 01-.398.96z"}}),_c('circle',{attrs:{"cx":"15.573","cy":"10.922","r":"1"}}),_c('path',{attrs:{"d":"M9.707 5.215a.563.563 0 01-.397-.96 2.313 2.313 0 000-3.265.562.562 0 01.795-.795 3.437 3.437 0 010 4.855.558.558 0 01-.398.165z"}}),_c('circle',{attrs:{"cx":"7.078","cy":"2.427","r":"1"}}),_c('circle',{attrs:{"cx":"17.393","cy":".607","r":"1"}}),_c('circle',{attrs:{"cx":"17.191","cy":"4.854","r":"1"}}),_c('path',{attrs:{"d":"M12.134 6.428a.563.563 0 01-.397-.96l3.843-3.843a.562.562 0 01.795.796l-3.843 3.843a.56.56 0 01-.398.164zm-1.622 1.056C8.842 5.822 6.52 4.77 5.314 5.974a1.425 1.425 0 00-.268.364C5.018 6.386.21 15.39.21 15.39a1.773 1.773 0 002.396 2.4l9-4.813c.158-.071.302-.173.422-.3 1.202-1.201.149-3.518-1.516-5.192zm.396 4.037l.006-.004-.006.004zm-.025.018c-.012.012-.045.055-.188.049-.681 0-1.95-.813-2.71-1.575-1.14-1.14-1.78-2.642-1.522-2.901a.278.278 0 01.186-.047 4.734 4.734 0 012.72 1.56c1.424 1.435 1.686 2.741 1.514 2.914z"}})])])
          )
        }
      }
    